import { TFunction } from 'i18next'
import { z } from 'zod'

export const GUEST_PASSES_DEFAULT_LIMIT = 25
export const GUEST_PASSES_MIN = 0
export const GUEST_PASSES_MAX = 1_000_000

export const INITIAL_FILTERS = {
  limit: GUEST_PASSES_DEFAULT_LIMIT,
  skip: 0,
}

export const makeGuestPassesSchema = (t: TFunction<['clients']>) => {
  const rangeMessage = t('clients:guestPasses.totalPasses.validation.range', {
    max: GUEST_PASSES_MAX.toLocaleString(),
    min: GUEST_PASSES_MIN,
  })

  return z.object({
    totalPasses: z.coerce
      .number()
      .min(GUEST_PASSES_MIN, rangeMessage)
      .max(GUEST_PASSES_MAX, rangeMessage),
  })
}
